import { initStore } from '../initStore'

export default {
  ...initStore('ClubStudent')
}
